module.exports = __webpack_public_path__ + "img/tips8.49934a75.png";